import { Box, Checkbox, Typography } from '@mui/material'
import { Fragment, memo, useMemo } from 'react'
import { TIMELINE_EVENT_KEY_LABEL } from '../../../../../../utils/constant'

const CodeTimelineFilter = ({ eventList, handleFilterChange }) => {
  // Variables
  const eventArray = useMemo(() => Object.keys(eventList || {}), [eventList])

  return eventArray?.length > 0 ? (
    <Box
      sx={{
        gap: '16px',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Typography fontWeight={700}>Events: </Typography>
      {eventArray.map((key) =>
        TIMELINE_EVENT_KEY_LABEL?.[key] ? (
          <Box
            key={key}
            sx={{
              gap: '4px',
              display: 'flex',
              cursor: 'pointer',
              alignItems: 'center'
            }}
            onClick={() => handleFilterChange(key, !eventList?.[key])}
          >
            <Checkbox checked={eventList?.[key]} sx={{ padding: 0 }} />
            {(key === 'gazeSegments' || key === 'violationSegments') && (
              <Box
                sx={{
                  width: '30px',
                  height: '10px',
                  borderRadius: '2px',
                  background: 'var(--warning-dark)'
                }}
              ></Box>
            )}
            <Typography>{TIMELINE_EVENT_KEY_LABEL?.[key]}</Typography>
          </Box>
        ) : (
          <Fragment key={key}></Fragment>
        )
      )}
    </Box>
  ) : (
    <></>
  )
}

export default memo(CodeTimelineFilter)
